// extracted by mini-css-extract-plugin
export default {"mainContainer":"FAQ_mainContainer__71PYf","header":"FAQ_header__rDuIB","faqSection":"FAQ_faqSection__zMOsV"};